module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_3009.ac0f4567.png";